import { redirect } from "react-router";

import { AUTH_ROUTE_PATHS } from "../../services/auth/authRouteConfig";
import {
  acquireAuthSession,
  getPendingLocation,
  waitForAuthDecision,
} from "../../services/auth/authSessionRuntime";
import { EXTERNAL_STATUS } from "../../services/auth/authStateMachine";
import { rememberDesiredNav } from "../../services/auth/desiredNavService";
import { hasLiveSession } from "./routePrefetch";

// The app shell route: every shell visit has a sign-in session, started here
// if boot didn't already start it (e.g. returning from the /login page).
export const authSessionMiddleware = async (_args, next) => {
  acquireAuthSession();
  return next();
};

// The full URL being navigated to. The request never carries the #hash, so it
// comes from the router's pending location when that is the same page.
const deepLinkOf = (request) => {
  const url = new URL(request.url);
  const pending = getPendingLocation();
  const hash =
    pending?.pathname === url.pathname && pending?.search === url.search
      ? pending.hash
      : "";
  // The document's origin, as PrivateRoute builds it.
  return `${globalThis.location.origin}${url.pathname}${url.search}${hash}`;
};

// Protected pages. Decides before any of the page's loaders run:
// - A token that is live right now goes straight through, so loaders start
//   their requests without waiting on the session (PrivateRoute still holds
//   the page until the session agrees).
// - Otherwise it waits for the session to decide. A session it renews (Entra's
//   refresh token) goes through with a fresh token; a signed-out user is sent
//   to sign in with the deep link kept, before the page renders.
//
// Mid-page changes (expiry while reading, logout in another tab) don't
// navigate, so PrivateRoute keeps reacting to those.
export const requireSignInMiddleware = async ({ request }, next) => {
  if (hasLiveSession()) {
    return next();
  }

  const status = await waitForAuthDecision(acquireAuthSession());
  if (status === EXTERNAL_STATUS.UNAUTHENTICATED) {
    rememberDesiredNav(deepLinkOf(request));
    throw redirect(AUTH_ROUTE_PATHS.AUTH_CHECK);
  }
  return next();
};
